import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteChildrenProps, Redirect } from 'react-router'
import StripeCallbackViewModel from './StripeCallbackViewModel'
import ContentLoading from 'components/ContentLoading'
import ContentError from 'components/ContentError'
import link from 'infra/link'
import styles from './StripeCallback.sass'

interface Props extends RouteChildrenProps {
  vm: StripeCallbackViewModel
}

export default observer(function StripeCallback({ vm, location }: Props) {
  useEffect(() => {
    const search = location.search
    vm.activate(search)
  }, [location.search])

  return (
    <div className={styles.root}>
      {vm.activate.match({
        pending: () => <ContentLoading />,
        rejected: (err: any) => <ContentError error={err} />,
        resolved: () => {
          return (
            <Redirect push={false} to={vm.redirectBackUrl || link.welcome()} />
          )
        },
      })}
    </div>
  )
})
